const buttons = [...document.querySelectorAll("[data-bundles-button]")];
const containers = [...document.querySelectorAll("[data-bundles-container]")];

buttons.forEach((button) => {
  button.addEventListener("click", function () {
    buttons.forEach((button) => button.classList.remove("active"));
    this.classList.add("active");
    let container = containers.find(
      (container) =>
        container.dataset.bundlesContainer === this.dataset.bundlesButton
    );
    containers.forEach((container) => container.classList.remove("active"));
    container.classList.add("active");
  });
});
